// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/../static/iconfont/iconfont.css";
import https from "@/units/https.js";
import url from "@/url";
import store from '@/store'

Vue.prototype.$https = https;
Vue.prototype.$url = url;
Vue.config.productionTip = false;
/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  // if (to.meta.content) {
  //   let head = document.getElementsByTagName("head");
  //   let meta = document.createElement("meta");
  //   document
  //     .querySelector('meta[name="keywords"]')
  //     .setAttribute("content", to.meta.content.keywords);
  //   document
  //     .querySelector('meta[name="description"]')
  //     .setAttribute("content", to.meta.content.description);
  //   meta.content = to.meta.content;
  //   head[0].appendChild(meta);
  // }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title + "-SYTEST AFM探针商城";
  }
  next();
});
Vue.use(ElementUI);

async function bootstrap () {
  try {
    await store.dispatch('GetTenantId')
    // 租户ID 需要先拿到（按域名识别），否则后续接口会报“无效的租户访问/请传入有效的租户ID”
    if (!store.getters || !store.getters.tenant_id) {
      throw new Error('未获取到租户ID')
    }

    await store.dispatch('GetAppInfo')
  } catch (err) {
    // 避免未处理的 Promise rejection 被 dev-server overlay 捕获成 [object Object]
    // eslint-disable-next-line no-console
    console.error('App bootstrap failed:', err && (err.message || err.msg) ? (err.message || err.msg) : err)
  } finally {
    /* eslint-disable no-new */
    new Vue({
      el: "#app",
      store,
      router,
      components: { App },
      template: "<App/>"
    });
  }
}

bootstrap()

